import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// @material-ui/icons
import { Search, AccessTime, SwapHoriz }from "@material-ui/icons";

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

import productStyle from "assets/jss/material-kit-react/views/landingPageSections/productStyle.jsx";

class ProductSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div id="product" className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>Comment ça marche ?</h2>
            <h5 className={classes.description}>
              La plateforme se charge de mettre en relation de particuliers souhaitant monétiser des moyens de transport écologiques comme leur vélo
              ou encore leur trotinette électrique avec d'autres particuliers souhaitant déposer leur voiture à l'entrée des grandes villes.
              Ce système éco-citoyen permet d'une part de créer une nouvelle source de revenus auprès des propriétaires en proposant à des locataires
              une solution rapide et efficace contre le manque de place de parking en centre ville et les embouteillages sur le dernier kilomètre
              de leur trajet ponctuel ou quotidien avec des économies à la clé.
            </h5>
          </GridItem>
        </GridContainer>
        <div>
          <GridContainer>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Trouvez"
                description="Trouver votre partenaire dekilo en fonction de vos besoins"
                icon={Search}
                iconColor="warning"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Réservez"
                description="Réservez votre moyen de transport en convenant avec le propriétaire la date et la durée de la location"
                icon={AccessTime}
                iconColor="info"
                vertical
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <InfoArea
                title="Echangez"
                description="Garez votre véhicule au plus proche de votre location et partez en ville en toute liberté"
                icon={SwapHoriz}
                iconColor="success"
                vertical
              />
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(productStyle)(ProductSection);



// WEBPACK FOOTER //
// ./src/views/LandingPage/Sections/ProductSection.jsx